
(function () {
  if (window.__rvDocappGiftAccordionNoJerkInitialized) return;
  window.__rvDocappGiftAccordionNoJerkInitialized = true;

  var observer = null;
  var isUpdating = false;
  var isQueued = false;
  var accordionOpenState = true;

  function getCartContainer() {
    return document.querySelector('#cart-drawer .cart-drawer__line-items');
  }

  function isLineItem(element) {
    return Boolean(element && element.matches && element.matches('line-item.line-item'));
  }

  function isDocappGift(element) {
    if (!isLineItem(element)) return false;

    if (element.hasAttribute('docapp-data-cart-item')) return true;
    if (element.querySelector('.docapp-free-gift-cart-price')) return true;
    if (element.querySelector('[docapp-data-href*="/products/docapp-free-gift-"]')) return true;

    var text = element.textContent || '';

    return text.indexOf('Gift ID') !== -1 || text.indexOf('🎁') !== -1;
  }

  function markPendingDirectGiftRows(container) {
    if (!container) return;

    Array.prototype.forEach.call(container.children, function (child) {
      if (isDocappGift(child)) {
        child.classList.add('rv-docapp-gift-pending');
      }
    });
  }

  function createAccordion() {
    var accordion = document.createElement('details');

    accordion.className = 'rv-cart-bundle-includes rv-docapp-gifts-accordion';
    accordion.open = accordionOpenState;

    accordion.innerHTML =
      '<summary class="rv-cart-bundle-includes__header">' +
        '<span class="rv-cart-bundle-includes__title">' +
          '<span class="rv-cart-bundle-includes__chevron" aria-hidden="true">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>' +
          ' Inclusief <span class="rv-docapp-gift-count-text">cadeaus</span>:' +
        '</span>' +
        '<span class="rv-cart-bundle-includes__meta">' +
          '<span class="rv-cart-bundle-includes__free-label">Gratis</span>' +
        '</span>' +
      '</summary>' +
      '<div class="gift-line-item-wrapper"></div>';

    return accordion;
  }

  function getDutchGiftCountText(count) {
    var words = {
      1: 'één',
      2: 'twee',
      3: 'drie',
      4: 'vier',
      5: 'vijf',
      6: 'zes',
      7: 'zeven',
      8: 'acht',
      9: 'negen',
      10: 'tien'
    };

    var countText = words[count] || count;

    return count === 1
      ? countText + ' cadeau'
      : countText + ' cadeaus';
  }

  function updateAccordionCount(accordion) {
    if (!accordion) return;

    var wrapper = accordion.querySelector(':scope > .gift-line-item-wrapper');
    if (!wrapper) return;

    var gifts = Array.prototype.filter.call(wrapper.children, function (child) {
      return isDocappGift(child);
    });

    var countTextElement = accordion.querySelector('.rv-docapp-gift-count-text');

    if (countTextElement) {
      countTextElement.textContent = getDutchGiftCountText(gifts.length);
    }

    if (!gifts.length) accordion.remove();
  }

  function collectDirectGiftBlocks(container) {
    var blocks = [];
    var currentBlock = [];

    Array.prototype.forEach.call(container.children, function (child) {
      if (isDocappGift(child)) {
        currentBlock.push(child);
        return;
      }

      if (currentBlock.length) {
        blocks.push(currentBlock);
        currentBlock = [];
      }
    });

    if (currentBlock.length) blocks.push(currentBlock);

    return blocks;
  }

  function findRelatedPaidProduct(giftBlock) {
    if (!giftBlock.length) return null;

    var sibling = giftBlock[giftBlock.length - 1].nextElementSibling;

    while (sibling) {
      if (isLineItem(sibling) && !isDocappGift(sibling)) return sibling;

      if (sibling.matches && sibling.matches('.rv-cart-bundle-line')) return null;

      sibling = sibling.nextElementSibling;
    }

    return null;
  }

  function getAccordionAfterPaidProduct(paidProduct) {
    if (!paidProduct) return null;

    var nextSibling = paidProduct.nextElementSibling;

    if (nextSibling && nextSibling.matches && nextSibling.matches('.rv-docapp-gifts-accordion')) {
      return nextSibling;
    }

    return null;
  }

  function moveGiftBlockIntoAccordion(giftBlock) {
    if (!giftBlock.length) return;

    var paidProduct = findRelatedPaidProduct(giftBlock);
    if (!paidProduct) return;

    var accordion = getAccordionAfterPaidProduct(paidProduct);

    if (!accordion) {
      accordion = createAccordion();
      paidProduct.insertAdjacentElement('afterend', accordion);
    }

    var wrapper = accordion.querySelector(':scope > .gift-line-item-wrapper');
    if (!wrapper) return;

    giftBlock.forEach(function (giftItem) {
      if (!isDocappGift(giftItem)) return;

      wrapper.appendChild(giftItem);
      giftItem.classList.remove('rv-docapp-gift-pending');
    });

    updateAccordionCount(accordion);
  }

  function cleanEmptyAccordions(container) {
    var accordions = container.querySelectorAll(':scope > .rv-docapp-gifts-accordion');

    accordions.forEach(function (accordion) {
      updateAccordionCount(accordion);
    });
  }

  function groupGiftItemsImmediately() {
    if (isUpdating) return;

    var container = getCartContainer();
    if (!container) return;

    markPendingDirectGiftRows(container);

    var giftBlocks = collectDirectGiftBlocks(container);

    if (!giftBlocks.length) {
      cleanEmptyAccordions(container);
      return;
    }

    isUpdating = true;

    if (observer) observer.disconnect();

    try {
      giftBlocks.forEach(function (giftBlock) {
        moveGiftBlockIntoAccordion(giftBlock);
      });

      cleanEmptyAccordions(container);
    } finally {
      isUpdating = false;
      startObserver();
    }
  }

  function queueImmediateGrouping() {
    if (isQueued) return;

    isQueued = true;

    queueMicrotask(function () {
      isQueued = false;
      groupGiftItemsImmediately();
    });
  }

  function mutationIsRelevant(mutation) {
    if (mutation.type === 'attributes') {
      var target = mutation.target;

      return Boolean(target && (target.matches('line-item.line-item') || target.closest('line-item.line-item')));
    }

    if (mutation.type !== 'childList') return false;

    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      if (!node || node.nodeType !== 1) return false;

      if (node.matches && (
        node.matches('#cart-drawer') ||
        node.matches('.cart-drawer__line-items') ||
        node.matches('line-item.line-item') ||
        node.matches('[docapp-data-cart-item]')
      )) {
        return true;
      }

      return Boolean(node.querySelector && (
        node.querySelector('#cart-drawer') ||
        node.querySelector('.cart-drawer__line-items') ||
        node.querySelector('line-item.line-item') ||
        node.querySelector('[docapp-data-cart-item]')
      ));
    });
  }

  function startObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(function (mutations) {
      if (isUpdating) return;

      var container = getCartContainer();

      if (container) markPendingDirectGiftRows(container);

      if (mutations.some(mutationIsRelevant)) {
        queueImmediateGrouping();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['docapp-data-cart-item']
    });
  }

  function runFallbackSequence() {
    queueImmediateGrouping();

    setTimeout(queueImmediateGrouping, 50);
    setTimeout(queueImmediateGrouping, 180);
    setTimeout(queueImmediateGrouping, 500);
  }

  function initializeGiftAccordion() {
    startObserver();
    runFallbackSequence();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGiftAccordion, { once: true });
  } else {
    initializeGiftAccordion();
  }

  document.addEventListener('toggle', function (event) {
    if (event.target.matches && event.target.matches('.rv-docapp-gifts-accordion')) {
      accordionOpenState = event.target.open;
    }
  }, true);

  document.addEventListener('cart:updated', runFallbackSequence);
  document.addEventListener('cart:change', runFallbackSequence);
  document.addEventListener('cart:refresh', runFallbackSequence);
  document.addEventListener('cart:rerender', runFallbackSequence);
  document.addEventListener('cart-drawer:open', runFallbackSequence);
  document.addEventListener('product:added', runFallbackSequence);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[name="add"]') ||
      event.target.closest('[data-add-to-cart]') ||
      event.target.closest('.atc_btn_instant') ||
      event.target.closest('#rv-add-to-cart')
    ) {
      runFallbackSequence();
    }
  });
})();